import { useMutation } from "urql";

import { RejectLimitRequestDocument } from "../../../graphql/generated.ts";

export const useRejectLimitRequest = () =>
  useMutation(RejectLimitRequestDocument);
